import { useEffect, useState } from 'react';
import { canShow3dPreview } from '@ff-os/shared-utils/can-show-3d-preview';

export const useHas3d = (defaultHas3d: boolean = true) => {

    const [has3d, setHas3d] = useState<boolean>(canShow3dPreview() && defaultHas3d);

    useEffect(() => {
        setHas3d(canShow3dPreview() && defaultHas3d);
    }, [defaultHas3d]);

    return has3d;
};